import { render, staticRenderFns } from "./vTrialLabelCongratulationsModal.vue?vue&type=template&id=08aeecd9&scoped=true"
import script from "./vTrialLabelCongratulationsModal.vue?vue&type=script&lang=ts"
export * from "./vTrialLabelCongratulationsModal.vue?vue&type=script&lang=ts"
import style0 from "./vTrialLabelCongratulationsModal.vue?vue&type=style&index=0&id=08aeecd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aeecd9",
  null
  
)

export default component.exports